import { p as proxyCustomElement, H, h } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';
import { d as defineCustomElement$2 } from './p-a5f885f9.js';

const selectOptionCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{z-index:10;padding:6px}:host:last-child{border-bottom:none;border-radius:0 0 4px 4px}:host button{font-family:\"museo-sans\", arial, sans-serif;padding:12px 6px;background-color:transparent;position:relative;border:none;width:100%;cursor:pointer;display:flex;word-wrap:break-word;overflow-wrap:break-word;text-align:start;overflow:hidden;align-items:center;gap:12px;font-size:1rem;line-height:1.5}:host button .icon{position:absolute;right:0;visibility:hidden}:host button .icon.selected{visibility:visible}:host button:disabled{cursor:default}:host button:not(:disabled):focus-visible{outline:none}:host button:not(:disabled):focus-visible{border-radius:4px;outline-offset:2px;outline:1.5px solid var(--bi-primary-50);box-shadow:0 0 0 2px white}:host button:not(:disabled):hover{cursor:pointer;background-color:#cfebff}:host button.small{font-size:0.75rem;line-height:1.5;padding:6px}:host(:first-child) button:focus-visible{border-top:none}";
const BiSelectOptionStyle0 = selectOptionCss;

const BiSelectOption$1 = /*@__PURE__*/ proxyCustomElement(class BiSelectOption extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /** If the option is disabled. */
        this.disabled = false;
        this.preventParentUpdate = false; // Used to prevent selected watcher from sending the value back to the parent
        this.getParent = () => {
            const select = this.el.closest('bi-select');
            if (select)
                return select;
            return this.el.closest('bi-select-multiple');
        };
        this.isCheckBoxVariant = () => this.getParent().tagName === 'BI-SELECT-MULTIPLE';
        this.handleClick = async (e) => {
            e.preventDefault();
            this.selected = !this.selected;
        };
    }
    onValueChange() {
        if (this.preventParentUpdate) {
            return;
        }
        this.getParent().onOptionChange(this.value);
    }
    /** Updates the selected without sending the new selected state back to the parent bi-select/bi-select-multiple */
    async updateSelected(val) {
        this.preventParentUpdate = true;
        this.selected = val;
        this.preventParentUpdate = false;
    }
    componentWillLoad() {
        if (this.defaultSelected) {
            this.updateSelected(this.defaultSelected ?? false);
        }
        else {
            this.defaultSelected = this.selected;
        }
        if (this.selected) {
            this.getParent().onOptionChange(this.value, true);
        }
    }
    render() {
        return (h("button", { key: 'd69e89cd49bd2a013b038656956957ace7363f35', "aria-disabled": String(this.disabled), "aria-selected": String(this.selected), disabled: this.disabled, onClick: this.handleClick, class: classNames({ selected: this.selected }, this.getParent().size) }, this.isCheckBoxVariant() && (h("bi-checkbox", { key: '22120b03de3c82664acb92bb7e45cd1a3b51c1f1', "aria-hidden": 'true', tabindex: -1, disabled: this.disabled, checked: this.selected })), this.label, !this.isCheckBoxVariant() && (h("bi-icon-checkmark", { key: 'c9b7a2147af7cae63afeb5f277195caaac6eb8ba', class: classNames('icon', { selected: this.selected }), color: 'primary', "aria-hidden": 'true', size: this.getParent().size || 'medium' }))));
    }
    get el() { return this; }
    static get watchers() { return {
        "selected": ["onValueChange"]
    }; }
    static get style() { return BiSelectOptionStyle0; }
}, [1, "bi-select-option", {
        "value": [1],
        "label": [1],
        "selected": [1028],
        "defaultSelected": [4, "default-selected"],
        "disabled": [4],
        "updateSelected": [64]
    }, undefined, {
        "selected": ["onValueChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-select-option", "bi-checkbox"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-select-option":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiSelectOption$1);
            }
            break;
        case "bi-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const BiSelectOption = BiSelectOption$1;
const defineCustomElement = defineCustomElement$1;

export { BiSelectOption, defineCustomElement };
